import { render, staticRenderFns } from "./RecommendNotMatchingReasons.vue?vue&type=template&id=40510b11"
import script from "./RecommendNotMatchingReasons.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecommendNotMatchingReasons.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports